import React from 'react';
import './styles.scss';
import { VIEW } from '@/types';
import { useInterfaceStore, useChatStore } from '@/hooks/stores';
import { useCustomComponent } from '@/hooks';
import Components from './components';

const ToggleViewComponent: React.FC = () => {
  const { widgetActiveView, setWidgetActiveView } = useInterfaceStore();
  const { isFormSubmitting } = useChatStore();
  return (
    <Components.Container>
      <Components.Option
        active={widgetActiveView === VIEW.HOME}
        onClick={() => setWidgetActiveView(VIEW.HOME)}
        disabled={isFormSubmitting}
      >
        <div className="peptalk-toggle-icon">
          <Components.Icon name="Home" />
        </div>
        <Components.Label>Home</Components.Label>
      </Components.Option>

      <Components.Option
        active={widgetActiveView === VIEW.CHAT}
        onClick={() => setWidgetActiveView(VIEW.CHAT)}
        disabled={isFormSubmitting}
      >
        <div className="peptalk-toggle-icon">
          <Components.Icon name="Message" />
        </div>
        <Components.Label>Messages</Components.Label>
      </Components.Option>
    </Components.Container>
  );
};

export const ToggleView: React.FC = props => {
  const Component = useCustomComponent({
    componentName: 'ToggleView',
    Component: ToggleViewComponent,
  });

  return <Component {...props} />;
};
